<template>
  <div>
    <!-- 面包屑导航 -->
  <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>工作台</el-breadcrumb-item>
      <el-breadcrumb-item>我的工作台</el-breadcrumb-item>
      <el-breadcrumb-item>部门预决算统计</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- Tabs -->
    <el-tabs v-model="activeName" type="border-card">
      <!-- 清单列表 strat -->
      <el-tab-pane label="清单列表" name="first">
        <!-- 查询 start -->
        <el-form :inline="true" :model="keywords" ref="keywordsRef" label-width="82px">
          <el-form-item label="">
            <RsljigouInternal :propsjigouid="keywords.jigouid" :propsjigouname="keywords.jigouname" @change="changeRsljigouInternal"></RsljigouInternal>
          </el-form-item>
          <el-form-item label="">
            <el-date-picker v-model="keywords.budgettimebegin" type="month" placeholder="选择月" class="select" value-format="yyyy-MM-dd"></el-date-picker>
          </el-form-item>
          <el-form-item label="">
            <el-date-picker v-model="keywords.budgettimeend" type="month" placeholder="选择月" class="select" value-format="yyyy-MM-dd"></el-date-picker>
          </el-form-item>
          <el-form-item label="">
            <el-input v-model="keywords.budgettype" @keyup.enter.native="clicksearch" placeholder="请输入费用分类" style="width: 150px;"></el-input>
          </el-form-item>
          <el-form-item label="">
            <el-input v-model="keywords.budgetdetail" @keyup.enter.native="clicksearch" placeholder="请输入费用描述" style="width: 150px;"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="clicksearch">查询</el-button>
            总预算金额:{{TJBudgetamount}};总实际支出:{{TJBudgetrealspending}}
          </el-form-item>
        </el-form>
        <!-- 查询 end -->

        <el-table :data="dataList" border stripe >
          <el-table-column prop="Jigouname" label="部门名称" header-align="center" align="center" min-width="8%"></el-table-column>
          <el-table-column prop="Budgettime" label="月份" header-align="center" align="center" min-width="8%"></el-table-column>
          <el-table-column prop="Budgettype" label="费用分类" header-align="center" align="center" min-width="8%"></el-table-column>
          <el-table-column prop="Budgetdetail" label="费用描述" header-align="center" align="center" min-width="18%"></el-table-column>
          <el-table-column prop="Budgetdanwei" label="单位" header-align="center" align="center" min-width="4%"></el-table-column>
          <el-table-column prop="Budgetnum" label="数量" header-align="center" align="center" min-width="4%"></el-table-column>
          <el-table-column prop="Budgetprice" label="单价" header-align="center" align="center" min-width="4%"></el-table-column>
          <el-table-column prop="Budgetamount" label="预算金额" header-align="center" align="center" min-width="5%"></el-table-column>
          <el-table-column prop="Budgetrealspending" label="实际支出" header-align="center" align="center" min-width="5%"></el-table-column>
          <el-table-column prop="Budgetsuppliername" label="供应商名称" header-align="center" align="center" min-width="9%"></el-table-column>
          <el-table-column prop="Budgetbeizhu" label="备注" header-align="center" align="center" min-width="12%"></el-table-column>
          <el-table-column prop="Budgetuseridcreatename" label="经办人" header-align="center" align="center" min-width="5%"></el-table-column>
          <el-table-column prop="Createtime" label="创建时间" header-align="center" align="center" min-width="10%"></el-table-column>
        </el-table>

        <!-- 分页 -->
<!--        <div class="pages">
          <el-pagination
            @current-change="handleCurrentPageChange"
            :page-size="8"
            layout="total, prev, pager, next, jumper"
            :total="dataListnum"
			:current-page.sync="selectedPageNo">
          </el-pagination>
        </div> -->
      </el-tab-pane>
      <!-- 清单列表 end -->

    </el-tabs>
    <!-- Tabs end -->
  </div>
</template>

<script>
import RsljigouInternal from '@/components/RsljigouInternal.vue'
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  components: {
    RsljigouInternal
  },
  name: 'MyWorkdepartmentbudgetstatistical',
  data () {
    return {
      activeName: 'first',
      selectedPageNo: 1,
      dataList: [],
      dataListnum: 0,
      // 筛选条件
      keywords: {
        jigouid: '-1',
        jigouname: '',
        budgettimebegin: '',
        budgettimeend: '',
        budgettype: '',
        budgetdetail: ''
      },
      TJBudgetamount: '',
      TJBudgetrealspending: ''
    }
  },
  mounted () {
    this.keywords.budgettimebegin = Vue.prototype.FunGetTimeStringShortFirst()
    this.keywords.budgettimeend = Vue.prototype.FunGetTimeStringShortFirst()
    // this.apiGetWorkdepartmentbudgetstatisticalNum()
    this.apiGetWorkdepartmentbudgetstatisticalList()
  },
  methods: {
    changeRsljigouInternal (vid, vname) {
      this.keywords.jigouid = vid
      this.keywords.jigouname = vname
    },
    clickreturn () {
      this.activeName = 'first'
      // this.apiGetWorkdepartmentbudgetstatisticalNum()
      this.apiGetWorkdepartmentbudgetstatisticalList()
    },
    handleCurrentPageChange (selectedPageNo) {
      this.apiGetWorkdepartmentbudgetstatisticalList()
    },
    clicksearch () {
      this.selectedPageNo = 1
      // this.apiGetWorkdepartmentbudgetstatisticalNum()
      this.apiGetWorkdepartmentbudgetstatisticalList()
    },
    apiGetWorkdepartmentbudgetstatisticalList: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        pageno: that.selectedPageNo,
        jigouid: that.keywords.jigouid,
        budgettimebegin: that.keywords.budgettimebegin,
        budgettimeend: that.keywords.budgettimeend,
        budgettype: that.keywords.budgettype,
        budgetdetail: that.keywords.budgetdetail
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetWorkdepartmentbudgetstatisticalList, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.dataList = response.data.List
            that.TJBudgetamount = response.data.TJBudgetamount
            that.TJBudgetrealspending = response.data.TJBudgetrealspending
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    }
    // apiGetWorkdepartmentbudgetstatisticalNum: function () {
    //   var that = this
    //   var useriderp = localStorage.getItem('Useriderp')
    //   var timestamp = Date.parse(new Date()) / 1000
    //   var data = {
    //     os: 'erp',
    //     useriderp: useriderp,
    //     timestamp: timestamp,
    //     localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
    //     jigouid: that.keywords.jigouid,
    //     budgettimebegin: that.keywords.budgettimebegin,
    //     budgettimeend: that.keywords.budgettimeend,
    //     budgettype: that.keywords.budgettype,
    //     budgetdetail: that.keywords.budgetdetail
    //   }
    //   // 加上签名
    //   data.sign = Vue.prototype.FunGetSignErp(data)
    //   axios.post(Vue.prototype.global.Url_GetWorkdepartmentbudgetstatisticalNum, Qs.stringify(data))
    //     .then(function (response) {
    //       if (response.data.Code === 200) {
    //         that.dataListnum = response.data.Num
    //       }
    //       Vue.prototype.FunCheckApiCodeBackground(response.data)
    //     })
    //     .catch(function (error) {
    //       Vue.prototype.FunLogError(error)
    //     })
    // }
  }
}
</script>

<style lang="less" scoped>

  .item {
    margin-top: 10px;
    margin-right: 40px;
  }

/deep/ .el-button--mini, .el-button--mini.is-round {
    padding: auto 5px;
}
.select{
   width: 202px;
}

.optometry {
    margin-top: 15px;
    padding: 20px;
    background: #FAFAFA;
    border: 1px solid #EBEEF5;

    & ul{
        flex-wrap: wrap;
        margin: 0;
        padding: 0;

        & li{
            width: 35%;
            line-height: 28px;
            color: #606266;
            list-style: none;
        }
    }
}
.mt20{
   margin-top: 20px;
}

.box-cardprimary{
    margin-top: 0px;
    background: #409eff;
    border: none;
    -webkit-box-shadow: 0 2px 16px 0 rgba(0, 0, 0, 0.05), 0 0 0px 0 rgba(0,0,0,0);
    box-shadow: 0 2px 16px 0 rgba(0, 0, 0, 0.05), 0 0 0px 0 rgba(0,0,0,0);
}

.box-cardwarning{
    margin-top: 0px;
    background: #ebb562;
    border: none;
    -webkit-box-shadow: 0 2px 16px 0 rgba(0, 0, 0, 0.05), 0 0 0px 0 rgba(0,0,0,0);
    box-shadow: 0 2px 16px 0 rgba(0, 0, 0, 0.05), 0 0 0px 0 rgba(0,0,0,0);
}

.box-carddanger{
    margin-top: 0px;
    background: #f56c6c;
    border: none;
    -webkit-box-shadow: 0 2px 16px 0 rgba(0, 0, 0, 0.05), 0 0 0px 0 rgba(0,0,0,0);
    box-shadow: 0 2px 16px 0 rgba(0, 0, 0, 0.05), 0 0 0px 0 rgba(0,0,0,0);
}

.userList{
    display: flex;
    align-items: center;
    .user{
        color:#ffffff;
        margin: 0 20px 0 0;
    }
    .number{
        font-size: 30px;
        margin: 0;
        font-weight: bold;
        color:#ffffff;
    }
}
</style>
